  <div pavan *ngIf="is_show_post_media_modal" id="SubscribeBoxModal" class="modal fade success-popup" tabindex="-1"
    role="dialog" [config]="{ show: true }" (onHidden)="onHidden()" bsModal #autoShownModal="bs-modal">
    <div class="custom-theme-modal modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="heading-4">
            Media
            <span (click)="hideModal()">
              <img class="meta-icon cursor-pointer" src="assets/themes/icons/cancel.svg" alt="cross">
            </span>
          </h4>
        </div>
        <div class="modal-body">
          <img *ngIf="media_type=='image'" [src]="is_show_post_media_modal_data[0]?.local" alt="img"/>
        </div>
      </div>
    </div>
  </div>